import { useEffect } from 'react'

const FULL_HEIGHT_DETENT = ['100%']

/**
 * Sizing props for a `BottomSheetModal`; `topInset` stays with the caller. A
 * gorhom scrollable reports only its own height, so a screen with one can't be
 * measured — it takes a fixed detent and sizes itself.
 */
export function sheetSizing({ fullHeight }: { fullHeight: boolean }) {
  return fullHeight
    ? { enableDynamicSizing: false, snapPoints: FULL_HEIGHT_DETENT }
    : { enableDynamicSizing: true }
}

const noop = () => {}

/**
 * `focusHook` that keeps `BottomSheetView`'s measuring but drops its
 * static-view registration, which over-drags the sheet on first touch. Calls
 * `useEffect` the way the default does, deps argument and all: React rejects a
 * slot whose argument count changes when a screen flips between the two.
 */
export function useInertScrollableFocus(_register: () => void) {
  useEffect(noop)
}
